// Lightweight GA4 event helper (tag installed globally in index.html)
export const track = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch { /* no-op */ }
};

export const SUPPORT_EMAIL = "support@taven.store";
